import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import Highlight from 'components/utils/highlight';

export default class Dropdown extends Component {
    static propTypes = {
        focus: PropTypes.bool.isRequired,
        suggesting: PropTypes.bool.isRequired,
        suggestions: ImmutablePropTypes.list.isRequired,
        suggestionIndex: PropTypes.number.isRequired,
        onItemFocus: PropTypes.func.isRequired,
        onEmptyClick: PropTypes.func.isRequired,
        onItemClick: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.focus !== this.props.focus
            || nextProps.suggesting !== this.props.suggesting
            || nextProps.suggestions !== this.props.suggestions
            || nextProps.suggestionIndex !== this.props.suggestionIndex
            || nextProps.onItemFocus !== this.props.onItemFocus
            || nextProps.onEmptyClick !== this.props.onEmptyClick
            || nextProps.onItemClick !== this.props.onItemClick;
    }

    @autobind
    handleMouseEnter(index) {
        return () => this.props.onItemFocus(index);
    }

    @autobind
    handleEmptyClick() {
        this.props.onEmptyClick();
    }

    render() {
        const {focus, suggesting, suggestions, suggestionIndex, onItemClick} = this.props;
        let children;

        if (!focus || !suggesting) return false;

        if (suggestions.size > 0) {
            children = suggestions.map((suggestion, index) => {
                const displayAs = suggestion.get('displayAs');
                const range = suggestion.get('range');
                const count = suggestion.get('count');
                const types = suggestion.get('types', []).map(type => i18next.t(type)).join(' / ');
                const className = classNames('cielo24-vwrap-item', {'cielo24-vwrap-active': index === suggestionIndex});
                return (
                    <button
                        type='button'
                        key={displayAs}
                        aria-label={displayAs}
                        className={className}
                        onMouseEnter={this.handleMouseEnter(index)}
                        onClick={onItemClick}
                    >
                        <span className='cielo24-vwrap-display-wrapper'>
                            <Highlight className='cielo24-vwrap-display' value={displayAs} range={range.toJS()} />
                            <span className='cielo24-vwrap-types'>{types}</span>
                        </span>
                        <span className='cielo24-vwrap-pill'>{count}</span>
                    </button>
                );
            });
        } else {
            const link = (
                <button
                    type='button'
                    className='cielo24-vwrap-explore'
                    onClick={this.handleEmptyClick}
                >
                    <strong>{i18next.t('try another search or explore')}</strong>
                </button>
            );
            children = (
                <div className='cielo24-vwrap-empty'>
                    <div className='cielo24-vwrap-display'>{i18next.t('No results found')}, {link}.</div>
                </div>
            );
        }

        return <div className='cielo24-vwrap-dropdown'>{children}</div>;
    }
}



// WEBPACK FOOTER //
// ./scripts/components/search/dropdown.js